
<template>
  <div class="px-3 py-1">
    <div class="fw-bold my-1">
      {{ trans(`subscription.classification_config.selector_type`) }}
    </div>
    <SelectorSelect v-model="select" />
    <RuleSmallButton
      :title="trans(`subscription.classification_config.selectors.selector_add`)"
      type="button"
      class="btn-secondary my-2"
      @click.native="AddSelector()"
    />
  </div>
</template>

<script>
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { SELECTOR_TYPE } from '@/constants'
export default {
  name: 'SelectorAdd',
  mixins: [selectorMixin],
  props: {
    reference: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      select: SELECTOR_TYPE.composite,
    }
  },
  methods: {
    AddSelector () {
      this.searchParentAddChild(this.reference, this.select, SELECTOR_TYPE.composite)
    },
  },
}
</script>
